<ng-container *ngIf="isCssReady">
  <div *ngIf="!data?.isForHub && !isEmbedded"
    class="transition-all hover:scale-[1.1] fixed top-1 px-3 py-1 flex items-center gap-3 cursor-pointer mobile:top-3"
    (click)="close()">
    <ig-image src="https://iti-images.s3.amazonaws.com/imgs/back-arrow.png"
      cls="w-[60px] h-[60px] mobile:w-[50px] mobile:h-[50px]"></ig-image>
    <span class="text-xl font-semibold text-white mobile:text-lg">BACK</span>
  </div>

  <div class="create-wrapper h-full flex justify-center items-center relative ig-db-theme-green">
    <mat-icon *ngIf="data?.isForHub"
      class="absolute top-4 right-4 text-gray-500 text-[18px] bg-gray-200 hover:bg-gray-300 flex items-center justify-center !w-7 !h-7 rounded-full cursor-pointer transition-all"
      (click)="close()">close</mat-icon>
    <div
      class="h-full flex shadow-2xl w-4/5 max-w-[1400px] mobile:block mobile:w-full mobile:h-full mobile:overflow-y-auto mobile:overflow-x-hidden"
      [class.!w-full]="data?.isForHub">
      <section *ngIf="!data?.isForHub" class="left-wrapper !w-1/3 relative hidden xl:block">
        <div class="w-full h-full bg-black opacity-20 absolute"></div>
        <div class="w-full h-full absolute text-white text-center pt-20 flex flex-col justify-between">
          <div>
            <div class="text-3xl font-semibold">Welcome</div>
            <div class="text-base mt-4 2xl:text-lg">
              Thank you for submitting your place!
            </div>
          </div>

          <div class="mb-24">
            <div class="text-sm max-w-[80%] m-auto">
              <ul>
                <li class="text-left list-disc">
                  Please provide as much information about your business as
                  possible.
                </li>
                <li class="text-left list-disc">
                  Allow at least 5 business days after submitting your business
                  for review and approval.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div class="w-full bg-white rounded-r-2xl pl-9 pr-4 py-6 text-gray-600 xl:w-2/3 mobile:px-6 mobile:pb-16"
        [class.!w-full]="data?.isForHub">
        <div class="text-2xl">Please fill in your place info</div>
        <div class="text-sm text-gray-400">
          Complete all required fields marked with an * to submit your place for
          approval
        </div>
        <section class="form-scroll-section w-full mt-4 py-2 h-[calc(100%-4rem)] overflow-y-auto pr-5 mobile:pr-0">
          <ig-field [control]="form.get('name')" label="Title" icon="stars"></ig-field>

          <!-- Location / Address with helper text -->
          <div
            class="address-field-wrapper mobile:mb-6"
            [class.address-field-invalid]="
              form.get('address').invalid && form.get('address').touched
            "
          >
            <ig-address-input
              #addressInput
              [control]="form.get('address')"
              class="block"
              [label]="'Location / Address *'"
            >
            </ig-address-input>

            <p class="address-helper-text text-sm text-gray-600 mb-0 mt-0 flex items-center gap-1">
              Please type the street address and select the correct address from the drop-down.
              <mat-icon
                class="!text-base !w-4 text-gray-400 cursor-help"
                matTooltip="Type a street address in the field above. A dropdown will appear with Google Maps suggestions. You must click on the correct address from the dropdown to select it. Manually typed addresses are not accepted."
              >help_outline</mat-icon>
            </p>
          </div>
          <ig-field [control]="form.get('website')" label="Your Website (if applicable)" icon="link"></ig-field>
          <ig-field [control]="form.get('facebookLink')" label="Facebook Page Link" icon="link"></ig-field>
          <ig-field [control]="form.get('category')" label="Category" icon="list" [isReadOnly]="true"
            (click)="showEditCategoryModal()"></ig-field>
          <ig-field [control]="form.get('phone')" label="Phone Number" icon="phone"></ig-field>
          <ig-field [control]="form.get('description')" mode="textarea" label="Description"
            icon="more_horiz"></ig-field>
          <div class="mb-6">
            <ig-hours-input [formControl]="form.get('opening_hours')"></ig-hours-input>
          </div>
          <ig-field [control]="form.get('imageLink')" label="Image Urls" icon="image" [hint]="hint">
          </ig-field>
          <div class="text-sm text-gray-500 relative">or</div>
          <div class="flex justify-between mt-1 mobile:mt-6">
            <div class="w-[19%]" *ngFor="let i of [].constructor(imageUploaders)">
              <ig-image-uploader [triggerRemoveImage]="imageLinks" (uploaded)="onImageUploaded($event)"
                (remove)="onRemoveImage($event)"></ig-image-uploader>
            </div>
          </div>
          <div class="owner-contact-info">
            <span>Owner Contact Information </span>
          </div>
          <hr />
          <span class="owner-contact-description">
            This information will not be listed on the public listing, but is provided to DMO if they need to reach out
            for further information.
          </span>
          <ig-field [control]="form.get('ownerEmail')" label="Owner Email Address" icon="mail"
            class="block mt-2"></ig-field>
          <ig-field [control]="form.get('ownerPhone')" label="Owner Phone Number" icon="phone"></ig-field>
          <mat-checkbox class="mb-2" [control]="form.get('hasCopyrights')" [(ngModel)]="hasCopyrights"
            *ngIf="isUsingLink || (uploadedImages && uploadedImages.length > 0)">
            Please note that any images uploaded or used in this software must either be royalty-free
            or owned by
            the client. By uploading or using an image, you
            acknowledge that you have the necessary rights to use it and that you will be solely responsible for any
            copyright infringement or other legal issues that may arise from the use of the image. We strongly advise
            our
            users to exercise due diligence and ensure that they have the necessary rights to use any images uploaded or
            used in this software.
          </mat-checkbox>

          <mat-checkbox *ngIf="data?.isForHub" class="!block !text-gray-500 -translate-y-3"
            (change)="setAsApprovedChange($event)">
            Set as Approved
          </mat-checkbox>

          <ig-button *ngIf="!hasSubmittedSuccessfully || data?.isForHub" theme (trigger)="submit($event)" cls="w-[160px] mb-6 mobile:w-full" [isAsync]="true"
            [disabled]="isFormInValid"
            [successText]="data?.isForHub ? 'Place created successfully!' : ''">
            SUBMIT PLACE
          </ig-button>

          <div
            *ngIf="hasSubmittedSuccessfully && !data?.isForHub"
            #submitSuccessBanner
            class="submit-success-banner submit-success-banner--inline mb-6"
            aria-live="polite"
          >
            <div class="submit-success-banner__icon">
              <mat-icon>check_circle</mat-icon>
            </div>
            <div class="submit-success-banner__content">
              <div class="submit-success-banner__title">Place submitted successfully</div>
              <p class="submit-success-banner__message mb-0">
                {{ submitSuccessMessage }}
              </p>
              <ig-button
                cls="submit-success-banner__action mt-4 mobile:w-full"
                mode="flat"
                (trigger)="submitAnotherListing()"
              >
                Submit Another Listing
              </ig-button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</ng-container>
